const routes = [{
  path: '/security/setting',
  component: () => import('@/views/security/setting'),
  name: 'security-setting',
  meta: {
    title: '安全设置'
  }
}, {
  path: '/change/password',
  component: () => import('@/views/changePwd'),
  name: 'change-password',
  meta: {
    title: '修改密码'
  }
}]

export default routes



// WEBPACK FOOTER //
// ./src/router/setting/security.js